import { FC, useCallback, useContext, useEffect, useState } from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import customTheme from '@theme/theme';
import './App.scss';
import { Route, RouterProvider, createBrowserRouter, createRoutesFromElements } from 'react-router-dom';
import { useIsAuthenticated } from '@azure/msal-react';
import { AppRoutes } from './routes/appRoutes';
import HomePage from './pages/HomePage/HomePage';
import SupplierFormPage from './pages/SupplierFormPage/SupplierFormPage';
import LoginPage from './pages/LoginPage/LoginPage';
import LoaderModal from '@components/LoaderModal/LoaderModal';
import ProtectedRoute from '@components/ProtectedRoute/ProtectedRoute';
// import axios from 'axios';
import { /* constantsApi, */ getConstants, getSuppliersTypes } from '@api/data';
// import { ConstantsReturnObject } from 'types/data';
import { StoreContext } from '@contexts/StoreContext';
import {
    setAddressTypes,
    setAttachmentTypes,
    setEntityTypes,
    setPaymentScope,
    setPaymentTypes,
    setSuppliers,
} from '@contexts/actions';
import { StoreContextType } from 'types/reducers';
import NewCustomerPage from '@pages/NewCustomerPage/NewCustomerPage';

const App: FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { dispatch } = useContext<StoreContextType>(StoreContext);
    const isAuthenticated = useIsAuthenticated();

    const fetchData = useCallback(() => {
        setIsLoading(true);
        getSuppliersTypes()
            .then((supplierItems) => {
                dispatch(setSuppliers(supplierItems));
            })
            .catch((error) => {
                console.log(error);
                dispatch(setSuppliers([]));
            });
        /* const supplierItems: SupplierItem[] = await axios
            .get(suppliersTypesApi)
            .then((value) => {
                if (value && value.data) {
                    return value.data as SupplierItem[];
                } else {
                    return [];
                }
            })
            .catch((error) => {
                console.log(error);
                return [];
            });
        if (supplierItems) {
            dispatch(setSuppliers(supplierItems));
        } */
        getConstants()
            .then((constants) => {
                if (constants) {
                    if (constants.ADDRESS_TYPE) {
                        dispatch(setAddressTypes(constants.ADDRESS_TYPE));
                    }
                    if (constants.ATTACHMENT_TYPE) {
                        dispatch(setAttachmentTypes(constants.ATTACHMENT_TYPE));
                    }
                    if (constants.ENTITY_TYPE) {
                        dispatch(setEntityTypes(constants.ENTITY_TYPE));
                    }
                    if (constants.PAYMENT_SCOPE) {
                        dispatch(setPaymentScope(constants.PAYMENT_SCOPE));
                    }
                    if (constants.PAYMENT_TYPE) {
                        dispatch(setPaymentTypes(constants.PAYMENT_TYPE));
                    }
                }
            })
            .catch((error) => {
                console.log(error);
            });
        /* const constants: ConstantsReturnObject | undefined = await axios
            .get(constantsApi)
            .then((value) => {
                if (value && value.data) {
                    return value.data as ConstantsReturnObject;
                } else {
                    return undefined;
                }
            })
            .catch((error) => {
                console.log(error);
                return undefined;
            });
        if (constants) {
            if (constants.ADDRESS_TYPE) {
                dispatch(setAddressTypes(constants.ADDRESS_TYPE));
            }
            if (constants.ATTACHMENT_TYPE) {
                dispatch(setAttachmentTypes(constants.ATTACHMENT_TYPE));
            }
            if (constants.ENTITY_TYPE) {
                dispatch(setEntityTypes(constants.ENTITY_TYPE));
            }
            if (constants.PAYMENT_SCOPE) {
                dispatch(setPaymentScope(constants.PAYMENT_SCOPE));
            }
            if (constants.PAYMENT_TYPE) {
                dispatch(setPaymentTypes(constants.PAYMENT_TYPE));
            }
        } */
        setIsLoading(false);
    }, [dispatch]);

    useEffect(() => {
        // Avoid firing API calls (401s) before Entra authentication completes
        if (isAuthenticated) {
            fetchData();
        }
    }, [fetchData, isAuthenticated]);

    const router = createBrowserRouter(
        createRoutesFromElements(
            <>
                <Route path={AppRoutes.LOGIN_PAGE} element={<LoginPage />} />
                <Route element={<ProtectedRoute />}>
                    <Route path={AppRoutes.HOME_PAGE} element={<HomePage />} />
                    <Route path={`${AppRoutes.SUPPLIER_FORM_PAGE}:tag`} element={<SupplierFormPage />} />
                    <Route path={`${AppRoutes.NEW_CUSTOMER_PAGE}:type`} element={<NewCustomerPage />} />
                </Route>
            </>,
        ),
    );

    return (
        <ChakraProvider theme={customTheme}>
            <RouterProvider router={router} />
            <LoaderModal isVisible={isLoading} />
        </ChakraProvider>
    );
};

export default App;
